<template>
        <span v-if="!compList.length">
            -
        </span>
        <span v-else-if="compList.length == 1">
            <span class="text-primary cursor-pointer" :title="compList[0].title" @click="()=>onOpen(compList[0])">
                {{ compList[0].number || compList[0].wo_number}} 
            </span>
        </span>
        <DropMenu v-else>
            <template v-slot:trigger="{ on }">
                <span class="text-primary cursor-pointer" v-on="on">
                    <span>
                        {{ compList[0].number || compList[0].wo_number}} [+{{ compList.length - 1}}] 
                    </span>
                </span> 
            </template>
                <v-list dense class="py-0" >
                    <ActionMenuItem no-icon action="workorder.open" v-for='(item, index) in compList' :key='index' class="text-primary cursor-pointer" @click="()=>onOpen(item)">
                        {{ item.number || item.wo_number }}
                    </ActionMenuItem>
                </v-list>
        </DropMenu>

</template>


<script setup>
    // Usage: 
    //   import WorkorderList from '@/features/salesinvoice/controls/WorkorderList'
    //
    //   <WorkorderList :list="model.workorders"></WorkorderList>

    import {computed, ref} from 'vue';
    import DropMenu from "@controls/menu/DropMenu.vue";
    import dlg from '@app/dlg'

    import ActionMenuItem from '@controls/menu/ActionMenuItem.vue'
    const props = defineProps({
        list: {
            type: [String, Array]
        },
    })

    const compList = computed({
        get() {
            var result = props.list || [];
            if (typeof result === 'string') {
                try {
                    result = JSON.parse(props.list) || [];
                } catch (e) {
                    console.error("Failed to parse workorder list:", e);
                    // ... and continue
                }
            }
            return result;
            //return [...result, ...result, ...result];
        }
    })

    function onOpen(item) {
        dlg.open('workorder', {id: item.id_workorder});
    }

</script>
